import { useCallback } from 'react';

import useLazyQueryWithPromise from '@hooks/useLazyQueryWithPromise';
import {
  FileResourceFragment,
  GetAttachmentDownloadDocument,
  GetAttachmentDownloadQuery,
  GetAttachmentDownloadQueryVariables,
  GetPdfDownloadDocument,
  GetPdfDownloadQuery,
  GetPdfDownloadQueryVariables
} from '@typing/Generated';
import { downloadFile } from '@utils/downloadUtils';

const useFileResourceDownloader = () => {
  const getPdfDownload = useLazyQueryWithPromise<GetPdfDownloadQuery, GetPdfDownloadQueryVariables>(
    GetPdfDownloadDocument
  );

  const attachmentFetch = useLazyQueryWithPromise<GetAttachmentDownloadQuery, GetAttachmentDownloadQueryVariables>(
    GetAttachmentDownloadDocument
  );

  const handleDownload = useCallback(
    (fr: FileResourceFragment, journeyId: string) => {
      const attachment = fr.attachment;

      if (!attachment || attachment.scanning) return;

      if (fr.pdfType) {
        getPdfDownload({
          fetchPolicy: 'no-cache',
          variables: { journeyId, type: fr.pdfType }
        }).then(response => {
          downloadFile(response.data.pdfDownload.url, 'grayce-resources.pdf');
        });
      } else {
        attachmentFetch({ fetchPolicy: 'no-cache', variables: { id: attachment.id } }).then(response => {
          if (response.data.attachmentDownload.url && response.data.attachmentDownload.filename) {
            downloadFile(response.data.attachmentDownload.url, response.data.attachmentDownload.filename);
          }
        });
      }
    },
    [attachmentFetch, getPdfDownload]
  );

  return { handleDownload };
};

export default useFileResourceDownloader;
